import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgDial = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 27" {...props}>
    <g fill="none" fillRule="evenodd" stroke="#C2C5CC">
      <rect width={5} height={5} x={0.5} y={0.5} rx={2.5} />
      <rect width={5} height={5} x={0.5} y={7.5} rx={2.5} />
      <rect width={5} height={5} x={7.5} y={7.5} rx={2.5} />
      <rect width={5} height={5} x={14.5} y={7.5} rx={2.5} />
      <rect width={5} height={5} x={0.5} y={14.5} rx={2.5} />
      <rect width={5} height={5} x={7.5} y={14.5} rx={2.5} />
      <rect width={5} height={5} x={7.5} y={21.5} rx={2.5} />
      <rect width={5} height={5} x={14.5} y={14.5} rx={2.5} />
      <rect width={5} height={5} x={7.5} y={0.5} rx={2.5} />
      <rect width={5} height={5} x={14.5} y={0.5} rx={2.5} />
    </g>
  </svg>
);
const Memo = memo(SvgDial);
export default Memo;
